import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {AppService} from '@shared/services/app.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'formly-footer',
  template: `
    <div class="flex justify-content-center">
      <div class="flex gap-2"
           [class.justify-content-end]="position === 'right'">
        <button *ngIf="hasSecondaryCommand"
                pButton
                type="button"
                [label]="secondaryLabel"
                class="p-button-secondary p-button-outlined w-12rem"
                (click)="onSecondaryAction()">
        </button>
        <button *ngIf="hasDeleteCommand"
                pButton
                type="button"
                label="Delete"
                class="p-button-danger p-button-outlined w-12rem"
                icon="pi pi-times"
                [disabled]="!hasId"
                (click)="onDelete()">
        </button>
        <button *ngIf="hasSaveAsCommand"
                pButton
                type="button"
                label="Save As.."
                icon="pi pi-plus"
                class="p-button-success p-button-outlined w-12rem"
                [disabled]="!hasId"
                (click)="onSaveAs()">
        </button>
        <button *ngIf="hasDuplicateCommand"
                pButton
                type="button"
                label="Duplicate"
                icon="pi pi-copy"
                class="p-button-duplicate w-12rem"
                [disabled]="!allowSave"
                (click)="onDuplicate()">
        </button>
        <button *ngIf="hasSaveCommand"
                pButton
                type="button"
                label="Save"
                icon="pi pi-plus"
                class="w-12rem"
                [disabled]="!allowSave"
                (click)="onSave()">
        </button>
      </div>
    </div>
  `,
  styles: []
})
export class FormlyFooterComponent implements OnInit, OnChanges {
  @Input() allowSave = true;
  @Input() position: 'left' | 'right' = 'right';

  @Input() secondaryLabel: string;
  @Input() model: { id?: string };
  @Input() confirmBeforeSave = true;

  @Output() save = new EventEmitter<void>();
  @Output() saveAs = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() secondary = new EventEmitter<void>();
  @Output() duplicate = new EventEmitter<void>();

  hasSaveCommand = false;
  hasDuplicateCommand = false;
  hasSaveAsCommand = false;
  hasDeleteCommand = false;
  hasSecondaryCommand = false;
  hasId = false;

  constructor(private app: AppService) {}

  ngOnInit(): void {
    this.updateCommands();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.hasId = !!this.model?.id;
    this.updateCommands();
  }

  private updateCommands() {
    this.hasSaveCommand = this.save.observers.length > 0;
    this.hasSaveAsCommand = this.saveAs.observers.length > 0;
    this.hasDeleteCommand = this.delete.observers.length > 0;
    this.hasSecondaryCommand = this.secondary.observers.length > 0;
    this.hasDuplicateCommand = this.duplicate.observers.length > 0;
  }

  onSave() {
    if (this.confirmBeforeSave) {
      this.app.confirmSave(() => {
        this.save.emit();
      });
    } else {
      this.save.emit();
    }
  }

  onDuplicate() {
    console.log('onDuplicate');
    if (this.confirmBeforeSave) {
      this.app.confirmDuplicate(() => {
        this.duplicate.emit();
      });
    } else {
      this.duplicate.emit();
    }

  }

  onDelete() {
    this.app.confirmDelete('', () => {
      this.delete.emit();
    });
  }

  onSecondaryAction() {
    this.secondary.emit();
  }

  onSaveAs() {
    this.saveAs.emit();
  }
}
